// Call Emissions
import { apiAuth } from '../../utils/hooks';

const getOneFootprint = (idFootprint, mode) => {
    return apiAuth(mode)
        .get(`/carbon/footprints/${idFootprint}`, { params: { detailed: '1' } })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getAllFootprints = (params, mode) => {
    return apiAuth(mode)
        .get('/carbon/footprints', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getCarbonReports = (params, mode) => {
    return apiAuth(mode)
        .get(`/carbon/statistics/reports`, { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export { getAllFootprints, getOneFootprint, getCarbonReports };
